import * as API from '../_api';
import i18n from '@/i18n';

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await API.create(one);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', i18n.t('user.error'), { root: true });
    return false;
  }
};

// @ts-ignore
export const del = async ({ dispatch }, one) => {
  try {
    await API.del(one);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', i18n.t('user.error'), { root: true });
    return false;
  }
};
